// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"482":"FluidFramework-HashFallback","606":"summarizerDelayLoadedModule"}[chunkId] || chunkId) + "." + {"162":"7f4880c4","482":"2d2df9a3","606":"e6be8931"}[chunkId] + ".chunk.js";
};